import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import * as Config from '../../config/Config';
import * as User from '../../helpers/User';
import Pagination from '../../helpers/Pagination';
import * as Common from '../../helpers/Common';
const $= window.$;
const jQuery = window.jQuery;

class YetactiveObservers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checkedValues:[],
			txtSubject:'',
			mailtxtcontractcont: '',
			pageOfItems:[],
			yetactiveob : props.yetactiveob,
			counter : '1',
			checkedmails:[]
		};
		//alert(JSON.stringify(props.yetactiveob));


		this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        // this.getSelectedRowKeys = this.getSelectedRowKeys.bind(this);
        this.onSelectAll = this.onSelectAll.bind(this);
        this.onRowSelect=this.onRowSelect.bind(this);
        this.clearForm  = this.clearForm.bind(this);
	}

	 componentWillReceiveProps(nextProps) {
	 	//alert('im in');
	 //	$('input:checkbox').removeAttr('checked');
         if(nextProps.yetactiveob!=undefined){
         	this.setState({
				yetactiveob:nextProps.yetactiveob,
				pageOfItems:nextProps.yetactiveob,

			})

         }

    }




	handleChange(e){
		this.setState({
			[e.target.name]:e.target.value
		})

	}

	clearForm(){

		 this.refs.table.setState({selectedRowKeys: []});

		 this.refs.table.cleanSelected();


		$('form#mentorhistory')[0].reset();
		 //$('input:checkbox').removeAttr('checked');
		 this.setState({
	     
          checkedmails:[]
	  	});



	}

	onChangePage(pageOfItems) {
		//alert(pageOfItems);
        // update state with new page of items
        this.setState({
        	pageOfItems: pageOfItems,

         });
    }

	onSubmit(e){


		// e.preventDefault();
		let learnerID = Common.getUserData("id", true);
		Common.reactLoader("show", "Please wait...");

			fetch(Config.domainUrl+'add-observer/resentmail', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    subject:this.state.txtSubject,
                    message:this.state.mailtxtcontractcont,
                    mailids:this.state.checkedmails,
			        learner_id:learnerID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	//alert(JSON.stringify(responseJson));
               	 Common.reactLoader("hide");
                if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {

			      	this.clearForm();
			      	$('#observermail').hide();


			        Common.message("", responseJson.message, "success");
			     //     if($('input[type="checkbox"]').is(':checked')){
				    // 	$('input[type="checkbox"]').prop('checked',false);
				    // }





			      }




   		 });






	}


 // getSelectedRowKeys(email) {
 //   // I think this answers your questions
 //   // alert('here');
 // 	 alert(email);
 //     // this.setState({checkedmails: this.state.checkedmails.concat([email])});
 //     // alert(this.state.checkedmails);
 //   //    var newState = React.addons.update(this.state, {
	//   //     list : {
	//   //       $push : [newObject]
	//   //     }
	//   // });

	//   // this.setState(newState);
 //    alert(this.refs.table.state.selectedRowKeys);
 //    // let formData = new FormData();
	//    //  let getdata=$('#getdata').serializeArray();

	//    //  let details = [];
	//    //     getdata.map((key,index)=>{
	//    //         details.push({[key.name]:key.value});
	//    //         formData.append(key.name,key.value);
	//    //     });

	//    //     alert(JSON.stringify(details));

 //  }

  onRowSelect(row, isSelected){
  var rowStr = "";

 // alert(isSelected);
  let  email = row['email'];
  //this.getSelectedRowKeys(email);
  if(isSelected == true){

  	 //this.setState({checkedmails: this.state.checkedmails.concat([email])});
  	 var joined = this.state.checkedmails.concat(email);
	 this.setState({ checkedmails: joined })

  }
  else if(isSelected== false){
 //  	this.setState({
	//   data: update(this.state.data, {$splice: [[index, 1]]})
	// })
	 var array = this.state.checkedmails;
	  var index = array.indexOf(email)
	  array.splice(index, 1);
	  this.setState({checkedmails: array });

	// var joined = this.state.checkedmails.filter(function(email) { return user.id != member.id });
	// this.setState({ users: users });
     //alert(this.state.checkedmails);
  }


}

onSelectAll(isSelected, currentDisplayAndSelectedData){
  // alert("is select all: " + isSelected);
  // alert("Current display and selected data: ");
  if(isSelected == true){
  	var mails = this.state.checkedmails;
	  for(let i=0;i<currentDisplayAndSelectedData.length;i++){
	     //alert(currentDisplayAndSelectedData[i]['email']);
	     let  email  = currentDisplayAndSelectedData[i]['email'];
	     //alert(email);
	     let mail  = mails.push(email);
	     //alert(mail);
	     //let mail = mail.join(',');

	  }
	   this.setState({ mails })
		//alert(this.state.checkedmails);

  }
  else if(isSelected== false){
 //  	this.setState({
	//   data: update(this.state.data, {$splice: [[index, 1]]})
	// })
	var array = this.state.checkedmails;
	 for(let i=0;i<currentDisplayAndSelectedData.length;i++){
	     //alert(currentDisplayAndSelectedData[i]['email']);
	     let  email  = currentDisplayAndSelectedData[i]['email'];
	     //alert(email);
	    var index = array.indexOf(email)
	 	 array.splice(index, 1);
	     //alert(mail);
	     //let mail = mail.join(',');

	  }


	  this.setState({checkedmails: array });

	// var joined = this.state.checkedmails.filter(function(email) { return user.id != member.id });
	// this.setState({ users: users });
     //alert(this.state.checkedmails);
  }
}



	componentDidMount() {

		$('#observermail').hide();
		this.refs.table.cleanSelected();
		 this.refs.table.setState({selectedRowKeys: []});
	 //    $( "#checkall" ).on('click',function(){

		//   if ($("#checkall").is(':checked')) {

		//     $('.chk_slct').prop("checked", true);

		//   }
		//   else
		//   {

		//     $('.chk_slct').prop("checked", false);

		//   }

		// });





	    jQuery( "#btnSubmit" ).on('click',function(){

		    var clickedonce = $('input[type="checkbox"]:checked').length;

			if(clickedonce <= 0){
				Common.message('Validation error','Please select an Observer to send mail.', "error")
			    //jQuery('#msgEmailChk').show();
			    $('#observermail').hide();

			}
			else
			{


				// var checkedValues = $('.chk_slct:checked').map(function() {
				//     return this.value;
				// }).get();



	   //          this.setState({
			 //        checkedValues: checkedValues
			 //      });

			  	//jQuery('#msgEmailChk').hide();

			  	$('#observermail').show();
			}


		}.bind(this));



	}


	render() {

		 if(this.state.checkedmails.length <= 0){
			$("#observermail").css('display','none');

		}



		// const {yetactiveob} = this.props;


    	  // alert(JSON.stringify(this.state.pageOfItems));
    	 // let mailids = this.state.checkedValues.map((mailid)=>{
    	 // 	return(
    	 // 		<span>{mailid},</span>
    	 // 		)
    	 // });

    	  let mailids = this.state.checkedmails.join(',');




		 // let rows = this.state.pageOfItems.map((yetactive,i) => {
		 // 	 var status = yetactive.approved;
		 // 	 var name = yetactive.name;
		 // 	 var gender = yetactive.gender;
		 // 	 var contact = yetactive.contact;
		 // 	 var status = yetactive.status;

		 // 	 var value = yetactive.sno;


   //          return (


	  //                  <tr key={`observer_${yetactive.assessor_id}`} id={yetactive.assessor_id}>
	  //                  		<td><input name={"MentorName"+ name} value={(gender==1) ? gender =  'Mr.'+ name : gender =  'Ms.'+ name} type="hidden" /><input type="checkbox" value={yetactive.email} name={`observer[${value}]`} id={'Chk'+ value} className="chk_slct" /></td>
		 //                   	<td>{value}</td>
			//                 <td>{yetactive.name}</td>
			//                 <td>{yetactive.relationship}</td>
			//                 <td>{yetactive.email}</td>
			//                 <td>{yetactive.isd_code +'-'+yetactive.std_code+ '-'+yetactive.phno}</td>
			//                 <td>{(status==2) ? status =  'declined' : status =  'Awaiting'}</td>
	  //                  </tr>
	  //               )


	  //      });





		const selectRowProp = {
		  mode: 'checkbox',
		  clickToSelect: true,
		  onSelect: this.onRowSelect,
		  onSelectAll: this.onSelectAll
		};

		var options = {
		    noDataText: 'You have no pending Observers.'
		};






		return (

			<div>
		<form id="getdata">

		<BootstrapTable ref='table' data={ this.state.yetactiveob } containerClass="myjourney-table"  ref="table" selectRow={ selectRowProp } options={options} pagination>
          <TableHeaderColumn dataField='sno' isKey>Sno</TableHeaderColumn>
          <TableHeaderColumn dataField='name'>Observer Name</TableHeaderColumn>
          <TableHeaderColumn dataField='relationship'>Relationship</TableHeaderColumn>
			<TableHeaderColumn dataField='email'>Email ID</TableHeaderColumn>
			<TableHeaderColumn dataField='contact'>Contact No</TableHeaderColumn>
			<TableHeaderColumn dataField='status'>Status</TableHeaderColumn>
      </BootstrapTable>
     </form>

				{/*<table border="0" width="100%" className="myjourney-table">
                    <thead>
                        <tr>
                        	<th><input type="checkbox" name="checkall" id="checkall"/></th>
                            <th>Sno</th>
                            <th>Observer Name</th>
                            <th>Relationship</th>
                            <th>Email ID</th>
                            <th>Contact No</th>
                            <th>Status</th>
                        </tr>
                    </thead>

				  	<tbody>
				  		{rows}
				  	</tbody>
				  	<input name="hidMail" id="hidMail" type="hidden" value={rows.length} />

				</table>
				<div className="pull-right">
					<Pagination items={this.state.yetactiveob} onChangePage={e=>this.onChangePage(e)} />
				</div>*/}


               <div className="observer-btn"  id="mailbtn">
                	<input type="submit"  name="btnSubmit" id="btnSubmit" value="Email Request" className="button-accept mail-icon" alt="Email Request" title="Email Request"/>
               </div>
                <form name="mentorhistory" id="mentorhistory">
                    <div className="viewobservers" id="observermail" >
				        <div className="table-cont5 tabgrey">
				          <div className="mentermailrow">
				              <div className="mentermaillft">To </div>
				              <div className="mentermailrgt" >{mailids}</div>
				          </div>
				          <div className="mentermailrow">
				              <div className="mentermaillft">Subject <span className="redtext">*</span></div>
				              <div className="mentermailrgt">
				              	<input type="text"  id="txtSubject" name="txtSubject" className="textbox" onChange={e=>this.handleChange(e)}/>

				              </div>
				          </div>
				          <div className="mentermailrow">
				              <div valign="top" className="mentermaillft">Message <span className="redtext">*</span></div>
				              <div className="mentermailrgt">
				              	<small> To review my request to become my observer, click here</small>
				              	<textarea name="mailtxtcontractcont"  cols="20" rows="15" id="mailtxtcontractcont" onChange={e=>this.handleChange(e)} ></textarea>

				              </div>
				          </div>
				          <input type="hidden" name="hidchkToaddress" id="hidchkToaddress" value={this.state.checkedValues}  />
				          <input type="hidden" name="hidName" id="hidName" value="" />
				          <input type="hidden" name="Names" id="Names" value="" />
				          <input type="hidden" name="Emails" id="Emails" value="" />
				          <div className="pwdpagespan" style={{float:'left'}}>
				           <span className="redstar">*</span> Required fields
				          </div>
				          <div className="mentermailrow">
				              <div className="mentermaillft">&nbsp;</div>
				              <div className="mentermailrgt" >
				            		<div className="button mailbtn">
					                  <input type="button" name="submit"  value="Send mail" className="mail-icon" alt="Send mail" title="Send mail" onClick={(e)=>this.onSubmit(e)}/>
					              </div>
					            </div>
					        </div>
				    	 </div>
				    </div>
				</form>
            </div>
		);
	}
}

export default YetactiveObservers;



// WEBPACK FOOTER //
// ./src/personal_interactions/observer/YetactiveObservers.js